(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'prop-types', 'clamp', './ImageShape', './Point'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'), require('clamp'), require('./ImageShape'), require('./Point'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes, global.clamp, global.ImageShape, global.Point);
        global.EnlargedImage = mod.exports;
    }
})(this, function (exports, _react, _propTypes, _clamp, _ImageShape, _Point) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _clamp2 = _interopRequireDefault(_clamp);

    var _ImageShape2 = _interopRequireDefault(_ImageShape);

    var _Point2 = _interopRequireDefault(_Point);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var _class = function (_React$Component) {
        _inherits(_class, _React$Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.state = {
                isTransitionEntering: false,
                isTransitionActive: false,
                isTransitionLeaving: false,
                isTransitionDone: false
            };
            return _this;
        }

        _createClass(_class, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var _this2 = this;

                var isHovering = nextProps.isHovering;


                if (isHovering === this.props.isHovering) {
                    return;
                }

                if (isHovering) {
                    this.setState({
                        isTransitionEntering: true
                    });

                    setTimeout(function () {
                        _this2.setState({
                            isTransitionEntering: false,
                            isTransitionActive: true
                        });
                    }, 0);
                } else {
                    this.setState({
                        isTransitionActive: false,
                        isTransitionLeaving: true
                    });

                    setTimeout(function () {
                        _this2.setState({
                            isTransitionLeaving: false
                        });
                    }, this.props.fadeDurationInMs);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _props = this.props,
                    containerClassName = _props.containerClassName,
                    containerStyle = _props.containerStyle,
                    cursorOffset = _props.cursorOffset,
                    position = _props.position,
                    fadeDurationInMs = _props.fadeDurationInMs,
                    imageClassName = _props.imageClassName,
                    imageStyle = _props.imageStyle,
                    isRenderOnDemand = _props.isRenderOnDemand,
                    largeImage = _props.largeImage,
                    smallImage = _props.smallImage,
                    imagePosition = _props.imagePosition;
                var _state = this.state,
                    isTransitionEntering = _state.isTransitionEntering,
                    isTransitionActive = _state.isTransitionActive,
                    isTransitionLeaving = _state.isTransitionLeaving;


                var offsetRatio = {
                    x: largeImage.width / smallImage.width,
                    y: largeImage.height / smallImage.height
                };

                var differentiatedImageCoordinates = {
                    x: Math.round((position.x - cursorOffset.x) * offsetRatio.x) * -1,
                    y: Math.round((position.y - cursorOffset.y) * offsetRatio.y) * -1
                };

                var minCoordinates = {
                    x: (largeImage.width - smallImage.width) * -1,
                    y: (largeImage.height - smallImage.height) * -1
                };

                var maxCoordinate = 0;

                var imageCoordinates = {
                    x: (0, _clamp2.default)(differentiatedImageCoordinates.x, minCoordinates.x, maxCoordinate),
                    y: (0, _clamp2.default)(differentiatedImageCoordinates.y, minCoordinates.y, maxCoordinate)
                };

                var isVisible = void 0;
                if (isTransitionEntering || isTransitionActive || isTransitionLeaving) {
                    isVisible = true;
                } else {
                    isVisible = false;
                }

                var imgDataHover = void 0;
                var defaultContainerStyle = {
                    position: 'absolute',
                    top: '0px',

                    overflow: 'hidden'
                };

                switch (imagePosition) {
                    case 'over':
                        imgDataHover = true;
                        defaultContainerStyle = Object.assign({}, defaultContainerStyle, {
                            left: '0px'
                        });
                        break;

                    case 'beside':
                    default:
                        imgDataHover = false;
                        defaultContainerStyle = Object.assign({}, defaultContainerStyle, {
                            left: '100%',
                            marginLeft: '10px',
                            border: '1px solid #d6d6d6'
                        });
                        break;
                }

                var computedContainerStyle = {
                    width: smallImage.width,
                    height: smallImage.height,
                    opacity: this.state.isTransitionActive ? 1 : 0,
                    transition: 'opacity ' + fadeDurationInMs + 'ms ease-in'
                };

                var translate = 'translate(' + imageCoordinates.x + 'px, ' + imageCoordinates.y + 'px)';

                var computedImageStyle = {
                    width: largeImage.width,
                    height: largeImage.height,
                    transform: translate,
                    WebkitTransform: translate,
                    msTransform: translate
                };

                var component = _react2.default.createElement(
                    'div',
                    {
                        className: containerClassName,
                        key: 'enlarged',
                        style: Object.assign({}, defaultContainerStyle, containerStyle, computedContainerStyle)
                    },
                    _react2.default.createElement('img', _extends({ 'data-hover': imgDataHover }, {
                        alt: largeImage.alt,
                        className: imageClassName,
                        src: largeImage.src,
                        srcSet: largeImage.srcSet,
                        sizes: largeImage.sizes,
                        style: Object.assign({}, imageStyle, computedImageStyle)
                    }))
                );

                if (isRenderOnDemand) {
                    return isVisible ? component : null;
                }

                return component;
            }
        }]);

        return _class;
    }(_react2.default.Component);

    _class.displayName = 'EnlargedImage';
    _class.defaultProps = {
        fadeDurationInMs: 0,
        isRenderOnDemand: true
    };
    _class.propTypes = {
        containerClassName: _propTypes2.default.string,
        containerStyle: _propTypes2.default.object,
        cursorOffset: _Point2.default,
        position: _Point2.default,
        fadeDurationInMs: _propTypes2.default.number,
        imageClassName: _propTypes2.default.string,
        imageStyle: _propTypes2.default.object,
        isHovering: _propTypes2.default.bool,
        isRenderOnDemand: _propTypes2.default.bool,
        largeImage: _ImageShape2.default,
        smallImage: _ImageShape2.default,
        imagePosition: _propTypes2.default.oneOf(['beside', 'over'])
    };
    exports.default = _class;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/EnlargedImage.js
 ** module id = 517
 ** module chunks = 0
 **/